module.exports = __webpack_public_path__ + "img/slider_4.15384525.jpg";